import { useState, useEffect } from "react"

/**
 * Provide the currently active heading on a content page.
 * Used in [components/on-this-page](../components/on-this-page/on-this-page.js)
 *
 * @param itemsInitializer A function returning an array of element IDs to look for.
 * @param offsetProportion The proportion of the viewport that visible elemenets are "active" in.
 */
const useScrollspy = ({ itemsInitializer = () => [], offsetProportion = 0.1 }) => {
  const [items] = useState(() => itemsInitializer().filter((i) => i != null))
  const [activeItem, setActiveItem] = useState()

  useEffect(() => {
    const updateScroll = throttle(80, () => {
      let activeItems = items.map(mapToElement).filter((element) => {
        // GetBoundingClientRect returns values relative to viewport
        // subtract 100 for sticky navigation header, this number should === the scroll-padding-block-start on html in basedom.scss
        return element.getBoundingClientRect().top - 100 - window.innerHeight * offsetProportion < 0
      })

      setActiveItem(activeItems.pop())
    })

    window.addEventListener("scroll", updateScroll)
    return () => {
      window.removeEventListener("scroll", updateScroll)
    }
  })

  if (typeof window === "undefined" || !window.document) {
    return // document is not available during server-side rendering
  }

  const mapToElement = document.getElementById.bind(document)
  return activeItem
}

const throttle = (threshold = 100, fn) => {
  let last
  let timer

  return () => {
    const now = +new Date()
    const timePassed = !!last && now < last + threshold

    if (timePassed) {
      clearTimeout(timer)

      timer = setTimeout(() => {
        last = now
        fn()
      }, threshold)
    } else {
      last = now
      fn()
    }
  }
}

export default useScrollspy
